// extracted by mini-css-extract-plugin
module.exports = {"mCurated":"sh","flipped":"th","mainContentContainer":"uh","cta":"vh","mainContentCtaDefault":"wh","disabled":"xh","mainContentCtaWhite":"yh"};